import { render, staticRenderFns } from "./infoPaciente.vue?vue&type=template&id=ba5558f0"
import script from "./infoPaciente.vue?vue&type=script&lang=js"
export * from "./infoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports